import { Navigate, useParams } from 'react-router-dom';
import { useGetConversationQuery } from '../../generated/graphql';
import { HelivanLoading } from '../HelivanLoading';
import { ViewConversation } from './ViewConversation';

export const ConversationViewRoute = () => {
  const { conversationId } = useParams();
  const { data, loading, error } = useGetConversationQuery({
    variables: { id: conversationId || '' },
  });

  if (loading) {
    return <HelivanLoading />;
  }

  if (error || !data?.getConversation) {
    return <Navigate to="/conversations" replace />;
  }

  return <ViewConversation data={data.getConversation} />;
};
